export const MODULE_STATUS_BAR_COLORS = {
    active: "#357DE8",
    assigned: "#22A06B",
    unassigned: "#B38600",
    inactive: "#E2483D",
} as const;

export type ModuleStatusBarColor = keyof typeof MODULE_STATUS_BAR_COLORS;

const STATUS_BARS_PATH =
    "M14 1.5L0 1.5L0 0L14 0V1.5ZM14 5.66667L0 5.66667L0 4.16667L14 4.16667V5.66667ZM14 9.83333L0 9.83333L0 8.33333L14 8.33333V9.83333ZM7 14L0 14L0 12.5L7 12.5V14Z";

export function ModuleStatusBarsIcon({
    color,
    size = 14,
    label = "",
}: {
    color: string;
    size?: number;
    label?: string;
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 14 14"
            fill="none"
            aria-label={label !== "" ? label : undefined}
            role={label !== "" ? "img" : "presentation"}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d={STATUS_BARS_PATH}
                fill={color}
            />
        </svg>
    );
}
